module.exports = __webpack_public_path__ + "images/花筑村全景_03.jpg?v=c423a579";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu5/花筑村全景_03.jpg
 ** module id = 88
 ** module chunks = 1 2
 **/